import React, { useState } from 'react';
import {
  Navbar,
  Nav,
  Collapse,
  NavItem,
  Button,
  NavbarToggler,
  NavbarBrand,
} from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';
import './NavArea.css';
import Container from 'reactstrap/lib/Container';

const NavArea = () => {
  const [collapsed, setCollapsed] = useState(true);

  const toggleNavbar = () => setCollapsed(!collapsed);

  return (
    <Container fluid>
      <Navbar className="" light expand="md">
        <NavbarBrand>
          <Link to="/">
            <strong>
              <h1 className="colorSection">Azim</h1>
            </strong>
          </Link>
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2 bg-danger" />
        <Collapse isOpen={!collapsed} navbar>
          <Nav
            style={{
              fontSize: '1.3rem',
            }}
            className="
               ml-auto
               justify-content-around
                align-items-center
                "
            navbar
          >
            <NavItem>
              <NavLink className="mr-4  colorSection" to="/projects">
                .Projects( )
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="mr-3 colorSection" to="/blog">
                .Blogs( )
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink className="mr-3 colorSection" to="/contact">
                .Contact( )
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className=" mr-3 colorSection" to="/about">
                .About( )
              </NavLink>
            </NavItem>
            <NavItem>
              {
                <Button outline color="danger" className="text-center ">
                  <a
                    className="mr-3 colorSection"
                    target="_blank"
                    rel="noreferrer"
                    href="https://drive.google.com/file/d/1ZHnVz2BarpsaEHGm3sQXfo6wibyqc-65/view?usp=sharing"
                  >
                    .Resume( )
                  </a>
                </Button>
              }
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </Container>
  );
};

export default NavArea;
